<template>
  <v-dialog v-model="dialogVisible" max-width="400">
    <v-card>
      <v-card-title class="headline">Confirm Deletion</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        Are you sure you would like to delete this {{ name }}?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click.native="cancel">
          Cancel
        </v-btn>
        <v-btn color="red darken-1" text @click.native="submit">
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    model: Boolean,
    name: {
      type: String,
      default: 'item'
    },
    didCancel: Function,
    didDelete: Function
  },
  data: () => ({
    dialogVisible: false
  }),
  watch: {
    model (val) {
      this.dialogVisible = val
    }
  },
  methods: {
    cancel () {
      this.$props.didCancel()
    },
    submit () {
      this.$props.didDelete()
    }
  }
}
</script>
